<template>
    <NuxtImg :src="url || 'user.svg'" class="w-10 h-10 rounded-full" alt="User profile picture" />
</template>


<script setup>
    const { url } = defineProps({
        url: {
            type: String,
            default: null
        }
    });
</script>
